export enum Stage {
  DEV,
  STG,
  PRD,
  DEPLOY_DEV,
  DEPLOY_STG,
  DEPLOY_PRD,
}

export function getBaseUrl() {
  if (typeof window !== "undefined")
    // browser should use relative path
    return "";
  if (process.env.VERCEL_URL)
    // reference for vercel.com
    return `https://${process.env.VERCEL_URL}`;
  if (process.env.RENDER_INTERNAL_HOSTNAME)
    // reference for render.com
    return `http://${process.env.RENDER_INTERNAL_HOSTNAME}:${process.env.PORT}`;
  // assume localhost
  return `http://localhost:${process.env.PORT ?? 3000}`;
}
export function getStage(): Stage {
  // See https://vercel.com/docs/concepts/projects/environment-variables
  if (process.env.VERCEL) {
    switch (process.env.VERCEL_ENV) {
      case "production":
        return Stage.DEPLOY_PRD;
      case "preview":
        return Stage.DEPLOY_STG;
      case "development":
        return Stage.DEPLOY_DEV;
    }
  }
  switch (process.env.DOPPLER_STAGE) {
    case "prd":
      return Stage.DEPLOY_PRD;
    case "stg":
      return Stage.DEPLOY_STG;
    case "dev":
      return Stage.DEV;
  }
  switch (process.env.NODE_ENV) {
    case "production":
      return Stage.PRD;
    case "development":
      return Stage.DEV;
  }
  return Stage.DEV;
}

export function isDeployed() {
  switch (getStage()) {
    case Stage.DEPLOY_DEV:
      return false;
    case Stage.DEPLOY_STG:
      return true;
    case Stage.DEPLOY_PRD:
      return true;
    case Stage.DEV:
      return false;
    case Stage.STG:
      return true;
    case Stage.PRD:
      return true;
    default:
      return false;
  }
}

export function getWebUrl() {
  switch (getStage()) {
    case Stage.DEV:
      return "http://localhost:3001";
    case Stage.STG:
      return "https://staging.areahub.info";
    case Stage.PRD:
      return "https://staging.areahub.info";
    case Stage.DEPLOY_DEV:
      return "https://staging.areahub.info";
    case Stage.DEPLOY_STG:
      return "https://staging.areahub.info";
    case Stage.DEPLOY_PRD:
      return "https://areahub.com";
    default:
      return "https://staging.areahub.info";
  }
}

export function getReportsUrl() {
  switch (getStage()) {
    case Stage.DEV:
      return "http://localhost:3002";
    case Stage.STG:
      return "https://staging-reports.areahub.info";
    case Stage.PRD:
      return "https://staging-reports.areahub.info";
    case Stage.DEPLOY_DEV:
      return "https://staging-reports.areahub.info";
    case Stage.DEPLOY_STG:
      return "https://staging-reports.areahub.info";
    case Stage.DEPLOY_PRD:
      return "https://reports.areahub.com";
    default:
      return "https://staging-reports.areahub.info";
  }
}

export function getWfPortalUrl() {
  switch (getStage()) {
    case Stage.DEV:
      return "https://staging-wildfires.areahub.info";
    case Stage.STG:
      return "https://staging-wildfires.areahub.info";
    case Stage.PRD:
      return "https://staging-wildfires.areahub.info";
    case Stage.DEPLOY_DEV:
      return "https://staging-wildfires.areahub.info";
    case Stage.DEPLOY_STG:
      return "https://staging-wildfires.areahub.info";
    case Stage.DEPLOY_PRD:
      return "https://wildfires.areahub.com";
    default:
      return "https://staging-wildfires.areahub.info";
  }
}

export function getDashboardUrl() {
  switch (getStage()) {
    case Stage.DEV:
      return "http://localhost:3000";
    case Stage.STG:
      return "https://staging-premium.areahub.info";
    case Stage.PRD:
      return "https://staging-premium.areahub.info";
    case Stage.DEPLOY_DEV:
      return "https://staging-premium.areahub.info";
    case Stage.DEPLOY_STG:
      return "https://staging-premium.areahub.info";
    case Stage.DEPLOY_PRD:
      return "https://premium.areahub.com";
    default:
      return "https://staging-premium.areahub.info";
  }
}

export function getCustomerBillingUrl() {
  switch (getStage()) {
    case Stage.DEV:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
    case Stage.STG:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
    case Stage.PRD:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
    case Stage.DEPLOY_DEV:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
    case Stage.DEPLOY_STG:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
    case Stage.DEPLOY_PRD:
      return "https://billing.stripe.com/p/login/6oEg0425l3On6be144";
    default:
      return "https://billing.stripe.com/p/login/test_cN2aHY5cxfWF7V6eUU";
  }
}

export function getHostName() {
  switch (getStage()) {
    case Stage.DEV:
      return "localhost";
    case Stage.STG:
      return "areahub.info";
    case Stage.PRD:
      return "areahub.com";
    case Stage.DEPLOY_DEV:
      return "localhost";
    case Stage.DEPLOY_STG:
      return "areahub.info";
    case Stage.DEPLOY_PRD:
      return "areahub.com";
    default:
      return "localhost";
  }
}
